<!--
 * @Description: 转签约
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-09 10:28:22
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-form ref="formRef" name="advanced_search" :model="form">
        <dc-layout-card :title="t('custom.turnToContractTitle')" :span="12">
          <template #subTitle>
            <a-button type="primary" @click="hanleAdd" ghost>{{ t('btn.add') }}</a-button>
          </template>
          <template v-for="(item, index) in form.contracts" :key="index">
            <div class="cos-form-line" v-if="index"></div>
            <dc-form-item
              :label="t('custom.contractCode')"
              :name="['contracts', index, 'contractCode']"
              :rules="{
                message: t('common.pleaseInput'),
                required: true
              }"
            >
              <CosInput v-model:value="item.contractCode" />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.signBodyName')"
              :name="['contracts', index, 'contractSubject']"
              :rules="{
                message: t('common.pleaseInput'),
                required: true
              }"
            >
              <CosInput v-model:value="item.contractSubject" />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.serviceSubject')"
              :name="['contracts', index, 'serviceSubject']"
              :rules="{
                message: t('common.pleaseSelect'),
                validator: selectForNumberValidate,
                required: true
              }"
            >
              <ParamCodesSelect paramCode="ofbu_service_body" appId="cos_ofbu" v-model:value="item.serviceSubject" />
            </dc-form-item>
            <dc-form-item
              :label="t('custom.arkCode')"
              :span="12"
              :name="['contracts', index, 'arkCode']"
              :rules="{
                message: t('common.pleaseSelect'),
                required: true
              }"
            >
              <div class="flex">
                <GcCodeSelect
                  v-model:label="item.arkCode"
                  v-model:value="item.arkCodeId"
                  :cosId="route.query.cosId"
                  :requiredCosId="true"
                  appId="cos_ofbu"
                />
                <a-button
                  type="text"
                  danger
                  style="padding-right: 0"
                  @click="hanleDel(index)"
                  v-show="form.contracts && form.contracts.length > 1"
                  >{{ t('btn.del') }}</a-button
                >
              </div>
            </dc-form-item>
          </template>
        </dc-layout-card>
      </a-form>
      <cos-footer-button
        v-model:value="form"
        :resetValue="resetValue"
        :formRef="formRef"
        :permissionPage="permissionBasic"
        :disabled="false"
        @submit="handleSubmit"
      ></cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { activation } from '@/api/overseasSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useRoute, useRouter } from 'vue-router'
import { selectForNumberValidate } from '@/utils/validate'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const formRef = ref()
const form = ref<{
  contracts: {
    arkCode?: string
    contractCode?: string
    contractSubject?: string
    serviceSubject?: number
  }[]
}>({
  contracts: [{}]
})
const resetValue = ref({
  contracts: [{}]
})
const permissionBasic = {
  save: 'ofbu_potential_contract_btn'
}
const hanleAdd = () => {
  form.value.contracts.push({})
}
const hanleDel = (index: number) => {
  form.value.contracts.splice(index, 1)
}
const handleSubmit = () => {
  // 转签约 或者流失激活
  activation({
    cosId: route.query.cosId,
    contracts: form.value.contracts
  }).then((res) => {
    layoutTags.close()
    message.success(t('tips.activitySuccess'))
    let type = 'contract'
    if (route.query.type === 'clients') {
      type = 'clients'
    }
    router.push({
      path: `/ofbu/${type}`
    })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuCustomerActive' }
</script>
